export default __webpack_public_path__ + "static/media/nttdata.cbdb1fbd.jpg";